import { UiSizes } from "@flightpath/coreui/dist/enums";
import { IF } from "../../../../components/hoc/If";
import { Button, ButtonTypes } from "../../../../components/ui/Button";
import { ButtonGroup } from "../../../../components/ui/ButtonGroup";
import { Panel } from "../../../../components/ui/Panel";
import { PositionedSpinner } from "../../../../components/ui/PositionedSpinner";
import I18n from "../../../../core/localization/I18n";
import { CountDisplay } from "../../projects/view/components/CountDisplay";
import { ReportingPie } from "../../projects/view/components/ReportingPie";
import { useState } from "react";
import {
  showActionsPerProjectByProgressStatusPieChartSidebar,
  showActionsPerProjectByRagStatusPieChartSidebar
} from "./Actions_modals";
import { ProgressStatus } from "../../../../enums";

export const ragColourArray = ["#F91E1E", "#F9AB1E", "#1AC541", "#58C8D1", "#BEBEBE"];
const impactAndActionCompletionDataColoursArray = [
  "#D3D3D3",
  "#FFD700",
  "#1AC541",
  "#FFA07A",
  "#B0E0E6",
  "#C0C0C0",
  "#ADD8E6"
];

export const ActionPies: React.FC<{
  isLoading: boolean;
  pieData: any[];
  count: number;
  progressData: any[];
  authUser: FP.Entities.IUser;
}> = ({ isLoading, count, pieData, progressData, authUser }) => {
  const [currentView, setCurrentView] = useState<"rag" | "progress">("rag");
  const percent = progressData ? Math.round(100 * (progressData[2].value / count)) : 0;

  return (
    <Panel.Panel hasBorder={true} background={Panel.PanelBackgrounds.BG_LIGHT} hasBorderRadius className="mb-4 p-3">
      <IF condition={isLoading}>
        <PositionedSpinner />
      </IF>
      <IF condition={!isLoading && count === 0}>
        <h3>No actions assigned</h3>
      </IF>
      <IF condition={!isLoading && count > 0}>
        <ButtonGroup size={UiSizes.XXS} isToggle={true} isVertical={false}>
          <Button onClick={() => setCurrentView("rag")} type={currentView !== "rag" && ButtonTypes.OUTLINE_PRIMARY}>
            Rag Status
          </Button>
          <Button
            onClick={() => setCurrentView("progress")}
            type={currentView !== "progress" && ButtonTypes.OUTLINE_PRIMARY}
          >
            Progress Status
          </Button>
        </ButtonGroup>
        <IF condition={currentView === "rag"}>
          <div className="row">
            <div className="col-5 p-0">
              <div className="col p-0">
                <CountDisplay
                  canView={true}
                  count={count}
                  label={I18n.t("phrases.yourActions")}
                  permissionLabel={I18n.t("warnings.noActionAccessPanel")}
                  drilldownDisabled={true}
                />
              </div>
            </div>
            <div className="col-7 p-0">
              <ReportingPie
                cls={"p-0"}
                data={pieData}
                colourArray={ragColourArray}
                onClick={pieData => {
                  const progressStatusCompleted = progressData.find(e => e.key === ProgressStatus.COMPLETED);
                  if (pieData.id === progressStatusCompleted.id) {
                    showActionsPerProjectByProgressStatusPieChartSidebar(authUser, pieData);
                  } else {
                    showActionsPerProjectByRagStatusPieChartSidebar(authUser, pieData);
                  }
                }}
              />
            </div>
          </div>
        </IF>
        <IF condition={currentView === "progress"}>
          <div className="row">
            <div className="col-5 p-0">
              <div className="col p-0">
                <CountDisplay
                  canView={true}
                  count={`${percent}%`}
                  label={I18n.t("phrases.actionsProgress")}
                  permissionLabel={I18n.t("warnings.noActionAccessPanel")}
                  subtitle={I18n.t("phrases.actionsComplete")}
                  drilldownDisabled={true}
                />
              </div>
            </div>
            <div className="col-7 p-0">
              <ReportingPie
                cls={"p-0"}
                data={progressData}
                colourArray={impactAndActionCompletionDataColoursArray}
                onClick={pieData => showActionsPerProjectByProgressStatusPieChartSidebar(authUser, pieData)}
              />
            </div>
          </div>
        </IF>
      </IF>
    </Panel.Panel>
  );
};
